import type { JSX } from 'react'
import type { IActionButtonProps } from '../ActionButton'

import { ButtonColors, ButtonCorners, ButtonFonts } from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import { COLOR, INDENTS } from 'vars/index'
import { ActionButton } from '../ActionButton'
import { ActionButtonColors, ButtonBordersWidth } from '../ActionButton.h'

export interface IPrimaryBaseInlineFavoriteAButtonProps extends IActionButtonProps {}

export const PrimaryBaseInlineFavoriteAButton = ({
  disabled,
  selected,
  icon = IconNames.favoriteToggle,
  font = ButtonFonts.Button1,
  colorDefault = ActionButtonColors.COLOR_MAIN_DEFAULT,
  colorSelectedDefault = ActionButtonColors.COLOR_MAIN_DEFAULT,
  colorHovered = ActionButtonColors.SURFACE_LIGHT_2,
  colorSelectedHovered = ActionButtonColors.SURFACE_LIGHT_2,
  colorPressed = ActionButtonColors.COLOR_MAIN_PRESSED,
  colorSelectedPressed = ActionButtonColors.COLOR_MAIN_PRESSED,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  paddings = [INDENTS.INDENT_0],
  corners = ButtonCorners.CORNERS_10,
  iconSize,
  ...rest
}: IPrimaryBaseInlineFavoriteAButtonProps): JSX.Element => {
  return (
    <ActionButton
      icon={icon}
      font={font}
      selected={!!selected}
      disabled={!!disabled}
      colorDefault={colorDefault}
      colorSelectedDefault={colorSelectedDefault}
      colorHovered={colorHovered}
      colorSelectedHovered={colorSelectedHovered}
      colorPressed={colorPressed}
      colorSelectedPressed={colorSelectedPressed}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      paddings={paddings}
      corners={corners}
      iconSize={iconSize}
      {...rest}
    />
  )
}
